import type { State } from './state';
import { getters as TYPES } from '@/store/product/types';

const getters = {
  [TYPES.GET_FETCH_ALL](state: State) {
    return state.product.fetchedAll;
  },
  [TYPES.GET_FETCH_ALL_QUERY](state: State) {
    return state.product.fetchedAllQuery;
  },
  [TYPES.GET_FETCH_ALL_PAGES](state: State) {
    return state.product.fetchedAllPages;
  },
  [TYPES.GET_FETCH_ALL_PAGES_QUERY](state: State) {
    return state.product.fetchedAllPagesQuery;
  },
  [TYPES.GET_FETCH_ALL_COLLECTIONS](state: State) {
    return state.product.fetchedAllCollections;
  },
  [TYPES.GET_FETCH_ALL_COLLECTIONS_QUERY](state: State) {
    return state.product.fetchedAllCollectionsQuery;
  },
};

export default getters;
